import { createContext, type PropsWithChildren, useContext } from 'react';
import type { AuthInfo } from '../hook/model/authInfo.ts';
import { findOrganizationByProjectId, isSamlEnforcementSatisfiedForProject } from '../utils/samlEnforcement';

type Organization = AuthInfo.Organization;

type Context = {
  organizations: Organization[];
};

const OrganizationContext = createContext<Context>({
  organizations: [],
});

export const useOrganization = () => {
  const { organizations } = useContext(OrganizationContext);
  if (!organizations) throw new Error('OrganizationProvider is not found');
  return {
    organizations,
    findOrganizationByProjectId: (projectId: string) => findOrganizationByProjectId(organizations, projectId),
    isSamlEnforcementSatisfiedForProject: (projectId: string) => isSamlEnforcementSatisfiedForProject(organizations, projectId),
  };
};

export const OrganizationProvider: React.FC<PropsWithChildren<Context>> = (props) => {
  const { organizations, children } = props;
  return <OrganizationContext.Provider value={{ organizations }}>{children}</OrganizationContext.Provider>;
};
